import { useTranslation } from 'react-i18next';

import { styled, Typography } from '@mui/material';

import banner_404 from 'Assets/images/banner_404.svg';
import { Link, SingleLine } from 'Components';
import { Colors } from 'Themes/colors';

import {
  ButtonLink,
  LeftColumn,
  StyledCloseButton,
  StyledContainer,
  StyledMuiLink,
  Wrapper
} from './NotFoundPage.styles';

const StyledImg = styled('img')`
  max-height: 450px;
`;

export const NotFoundPage = () => {
  const { t } = useTranslation();

  const handleBackClick = () => window.history.back();

  return (
    <StyledContainer>
      <Wrapper>
        <LeftColumn>
          <Typography>{t('notFoundPage.title')}</Typography>
          <Typography fontSize="164px" fontWeight={700} color={Colors.black}>
            404
          </Typography>
          <Typography>{t('notFoundPage.firstLine')}</Typography>
          <SingleLine>
            <ButtonLink onClick={handleBackClick}>{t('notFoundPage.backButton')}</ButtonLink>
            <Typography>{t('notFoundPage.secondLine')}</Typography>
            <Link to="/" label={t('notFoundPage.mainPage')} />
          </SingleLine>
          <SingleLine>
            <Typography>{t('notFoundPage.thirdLine')}</Typography>
            <StyledMuiLink href="mailto:kontakt@treneo.pl">kontakt@treneo.pl</StyledMuiLink>
          </SingleLine>
        </LeftColumn>
        <StyledImg src={banner_404} alt="banner 404"></StyledImg>
        <StyledCloseButton onClose={handleBackClick} />
      </Wrapper>
    </StyledContainer>
  );
};
